import { ModelDetails } from "./components";

export const mapModelsData = (data) => {
  return data.map(el => {
    return {
      id: el.id,
      name: el.modalName,
      data: {
        ...el
      },
      component: ModelDetails,
      customTabListTitle: el.modalName,
      customTabListSubTitle: null,
      customTabPanelTitle: null
    };
  });
}

export const mapMultimodalTransportationFormData = (formData, transportTypes) => {
  if (transportTypes) {
    return formData.map(row => {
      return {
        id: row.id,
        typeOfTransport: transportTypes.find(type => type.code === row.typeOfTransport)?.id ?? "",
        subtypeOfTransport: transportTypes.find(type => type.code === row.typeOfTransport)?.subtypes?.find(
          sub => sub.code === row.subtypeOfTransport)?.id ?? "",
        subtypeTwo: row.subtypeTwo !== "" ?
          transportTypes.find(type => type.code === row.typeOfTransport)?.subtypes?.find(
            sub => sub.code === row.subtypeOfTransport)?.subtypeTwos?.find(
            sub2 => sub2.code === row.subtypeTwo)?.id ?? "" : "",
        distance: row.distance
      }
    })
  }
  return [];
};